import React, { Component } from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Paper from '@material-ui/core/Paper';
import './branch.css';
import Edit from './edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import Add from './add';
import { Button, Icon, Grid, Image } from 'semantic-ui-react'
import ReadCookie from '../../../functions/readcookies';
import Addicon from '../../media/add.png';
import View from './logo';

class Branch extends Component {

  state = {
    data: [],
    load: false,
    message: '',
    editDialog: false,
    deleteDialog: false,
    adddialog: false,
    file: Addicon,
    paymentmode: []
  }

  componentDidMount() {
    this.getBranch();
    this.getPaymentMode();
  }

  getPaymentMode() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Paymentmode' })
    $.ajax({
      type: 'POST',
      data: { 'executiveid': userId },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ paymentmode: data, load: false })
        } catch (e) { context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getBranch() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Branch Details'
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'branchdetails/get.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            load: false,
            data: data
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleClose = () => {
   this.setState({ editDialog: false, deleteDialog: false, adddialog: false });
  };

  edit(name, address, taluk, district, state, id, phone, pincode, gstin) {
    this.setState({
      name: name,
      address: address,
      taluk: taluk,
      district: district,
      state: state,
      id: id,
      phone: phone,
      pincode: pincode,
      gstin: gstin,
      editDialog: true,
    })
  }

  updateData(data) {
    this.setState({
      data: data,
      editDialog: false
    })
  }

  updateDatas() {
    this.getBranch();
    this.setState({
      adddialog: false,
    });
  }

  removeBranchDetails() {
    let context = this;
    context.setState({
      load: true,
      message: 'Deleting Branch Details'
    })
    let data1 = {'id': this.state.deleteid};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'branchdetails/delete.php',
      success: function(data)
      {
        context.setState({
          load: false,
          deleteDialog: false,
        })
        if (data == 1) {
          context.update(context.state.deleteid);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  delete(id) {
    this.setState({
      deleteid: id,
      deleteDialog: true
    })
  }

  update(id) {
    let data = this.state.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.setState({
      data: dele,
    })
  }

  addBranch() {
    this.setState({
      adddialog: true,
    });
  }

  handleFile = e => {
    this.updateLocalfile(e.target.files[0]);
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  submitMode(mode) {
    let context = this;
    let  { branchId } = context.state;
    context.setState({ load: true, message: 'Mode Changing!!!' })
    $.ajax({
      type: 'POST', data: { mode, branchId },
      url: Server() + 'branchdetails/changemode.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ load: false, dialogOpenMode: false })
          context.getBranch();
        }
        else {
          context.setState({ load: false })
          alert('Error!!!');
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }


  render() {
    const { fullScreen } = this.props;
    const { load, data, adddialog, message, editDialog, deleteDialog } = this.state;
    return (
      <div style={{padding: '1%'}}>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={13}>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={3}>
            <br/>
            { this.props.menuPermission.add ?
            <Button primary onClick={this.addBranch.bind(this)} style={{display: this.state.branchedit}} fluid icon labelPosition='left'>
              <Icon name='plus' />
              Add Branch
            </Button>:''}
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <table width='100%' id='table'>
                <tr id='tablehead'>
                  <th style={{fontSize: 14, color: 'white', width: '3%'}}>S.No</th>
                  <th style={{fontSize: 14, color: 'white', width: '5%'}}>Logo</th>
                  <th style={{fontSize: 14, color: 'white'}}>Name</th>
                  <th style={{fontSize: 14, color: 'white', width: '3%'}}>Code</th>
                  <th style={{fontSize: 14, color: 'white', width: '7%'}}>Phone</th>
                  <th style={{fontSize: 14, color: 'white', width: '15%'}}>Address</th>
                  <th style={{fontSize: 14, color: 'white'}}>Taluk</th>
                  <th style={{fontSize: 14, color: 'white'}}>District</th>
                  <th style={{fontSize: 14, color: 'white'}}>State</th>
                  <th style={{fontSize: 14, color: 'white'}}>Pincode</th>
                  <th style={{fontSize: 14, color: 'white'}}>GSTIN</th>
                  <th style={{fontSize: 14, color: 'white'}}>Cash Mode</th>
                  { this.props.menuPermission.edit ?
                    <th style={{fontSize: 14, color: 'white'}}><center>Edit</center></th>:''
                  }
                </tr>
                {data.map(row => (
                  <tr id='rowselect'>
                    <td style={{fontSize: 14}}>{row.sino}</td>
                    <td style={{fontSize: 14}}>
                      <View menuPermission={this.props.menuPermission} getBranch={this.getBranch.bind(this)} branchId={row.id} logo={row.logo} />
                    </td>
                    <td style={{fontSize: 14}}>{row.name}</td>
                    <td style={{fontSize: 14}}><center>{row.code}</center></td>
                    <td style={{fontSize: 14}}>{row.phone}</td>
                    <td style={{fontSize: 14}}>{row.address}</td>
                    <td style={{fontSize: 14}}>{row.taluk}</td>
                    <td style={{fontSize: 14}}>{row.district}</td>
                    <td style={{fontSize: 14}}>{row.state}</td>
                    <td style={{fontSize: 14}}>{row.pincode}</td>
                    <td style={{fontSize: 14}}>{row.gstin}</td>
                    <td style={{fontSize: 14}} onClick={ () => { this.setState({ dialogOpenMode: true, branchId: row.id }) }}>{row.mode}</td>
                    { this.props.menuPermission.edit ?
                      <td onClick={this.edit.bind(this, row.name, row.address, row.taluk,
                        row.district, row.state, row.id,
                        row.phone, row.pincode, row.gstin)}
                        style={{color: 'blue', cursor: 'pointer', fontSize: 14, display: this.state.branchedit}}>
                        <center>Edit</center>
                      </td>:''
                    }
                  </tr>
                ))}
            </table>
          </Grid.Column>
        </Grid>


        <Dialog fullScreen={fullScreen} open={this.state.dialogOpenMode}
          onClose={ () => { this.setState({ dialogOpenMode: false }) }} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 300}}>
            {"Cash Mode For Branch"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {
                this.state.paymentmode.map((c) => {
                  return (
                    <div style={{marginTop: '20px', marginBottom: '20px'}}>
                      <b style={{cursor: 'pointer', color: 'black'}} onClick={this.submitMode.bind(this, c.id)}>{c.mode}</b>
                    </div>
                  )
                })
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialogOpenMode: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>



        <Dialog fullScreen={fullScreen} open={editDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Edit Branch"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Edit name ={this.state.name} address={this.state.address}
                    taluk={this.state.taluk} district ={this.state.district}
                    state={this.state.state} id={this.state.id}
                    phone={this.state.phone} pincode={this.state.pincode}
                    gstin={this.state.gstin}
                    data={this.state.data} updateData={this.updateData.bind(this)}
                    handleClose={this.handleClose}  />
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={adddialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Add Branch"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
                <Add updateDatas={this.updateDatas.bind(this)}
                handleClose={this.handleClose} />
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={deleteDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 100}}>
            {"Delete Branch"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>Do you want to remove it!!</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.handleClose.bind(this)} color="secondary">
              NO
            </Buttons>
            <Buttons onClick={this.removeBranchDetails.bind(this)} color="primary" autoFocus>
              Yes
            </Buttons>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Branch;
